import styled, { css } from 'styled-components';

const containerMaxWidth = '537px';

export const StyledComponent = styled.div`
    ${props => props.theme &&
        props.theme.ns && css`
            border: 1px solid #ff00ff;
    `}
`;

export const StyledContainer = styled.div``;

export const StyledBodyContainer = styled.div`
    max-width: ${containerMaxWidth};
    margin: 0 auto;
    padding: ${props => props.theme.ns().spacing.xs()};
`;

export const StyledBannerContainer = styled.div``;

export const StyledActionsContainer = styled.div`
    padding: 0 ${props => props.theme.ns().spacing.md()};
`;
